import React from 'react';
import { connect } from 'react-redux';
import { RootState } from './store';
import { iSession } from './interfaces/session';
import { BrowserRouter } from 'react-router-dom';
import Screens from './screens';

interface StoreProps {
    Session: iSession;
}

interface DispatchProps {
}

type Props = StoreProps & DispatchProps;

class App extends React.Component<Props> {

  componentDidMount(): void {
    window.history.scrollRestoration = "manual";
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<{}>, snapshot?: any): void {
  }

  render() {
    const { Session } = this.props;

    return (
      <div id="app" className={Session.route}>
        <BrowserRouter>
          <Screens />
        </BrowserRouter>
      </div>
    )
  }
}

const storeToProps = (state: RootState) => {
  return {
    Session: state.session
  }
}

const dispatchToProps = {
};

export default connect(storeToProps, dispatchToProps)(App);
